// Vyhledávání v celé aplikaci (krok 12.6, kontrakt `hledatGlobalne`): `GET /hledat?q=&druhy=&limit=`.
// Pole v hlavičce volá dvě kola souběžně — záznamy (zakázky, zákazníci, doklady, lístky, smlouvy, vozidla, odpady
// z katalogu položek, zaměstnanci a sekce aplikace; skupinu, na kterou účet nemá právo, server nevrátí) hned
// a dokumenty podle smyslu zvlášť, protože model potřebuje víc času (09 §12: rychlé výsledky se na model nečekají).
// Starý požadavek zruší react-query: dotaz s novým textem nahradí starý a jeho `signal` se přeruší.
import type { Schema } from '@ecoser/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from './klient';

export type HledaniVysledek = Schema<'HledaniVysledek'>;
export type HledaniSkupina = Schema<'HledaniSkupina'>;
export type HledaniPolozka = Schema<'HledaniPolozka'>;

export const AKCE_HLEDANI = 'hledani.globalni';
/** Druhy prvního kola (bez dokumentů podle smyslu). */
export const DRUHY_ZAZNAMU =
  'zakazky,zakaznici,doklady,vazni_listky,smlouvy,vozidla,odpady,zamestnanci,sekce';
export const MIN_DELKA_DOTAZU = 2;

/** Stejné pravidlo jako server (`lzeHledat`): aspoň 2 znaky bez mezer a interpunkce. */
export function lzeHledat(text: string): boolean {
  return text.replace(/[\s\p{P}\p{S}]+/gu, '').length >= MIN_DELKA_DOTAZU;
}

export type KoloHledani = 'zaznamy' | 'dokumenty';

export function useHledani(text: string, kolo: KoloHledani, povoleno = true) {
  const q = text.trim();
  return useQuery({
    queryKey: ['hledani', kolo, q] as const,
    queryFn: ({ signal }) => {
      const parametry = new URLSearchParams({
        q,
        druhy: kolo === 'zaznamy' ? DRUHY_ZAZNAMU : 'dokumenty',
        limit: '5',
      });
      return api.get<HledaniVysledek>(`/hledat?${parametry.toString()}`, { signal });
    },
    enabled: povoleno && lzeHledat(q),
    staleTime: 30_000,
    // Při psaní zůstávají vidět výsledky předchozího textu, dokud nepřijdou nové (bez blikání prázdna).
    placeholderData: keepPreviousData,
  });
}
